import { render, staticRenderFns } from "./auctionHall.vue?vue&type=template&id=1c19becc&scoped=true&"
import script from "./auctionHall.vue?vue&type=script&lang=js&"
export * from "./auctionHall.vue?vue&type=script&lang=js&"
import style0 from "./auctionHall.vue?vue&type=style&index=0&id=1c19becc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c19becc",
  null
  
)

export default component.exports